//@ts-nocheck
import React, { useEffect } from 'react'
import Tooltip from '../Tooltip'
import { Icon } from '../../../../../index'
import { css, cx } from '@emotion/css'
//@ts-ignore
import styles from './style.module.css'

const config = {
  placement: 'bottom',
  arrow: false,
  offset: [0, 0],
  delay: [300, 0],
  duration: [0, 0],
  hideOnClick: true,
  theme: 'small',
}

export declare interface DndIconTyes extends React.HTMLAttributes<HTMLSpanElement> { }
export const DndIcon = React.forwardRef((props: DndIconTyes, ref) => {
  return (
    <Tooltip
      content={<span className={styles['draggable-tooltip']}>Drag to move</span>}
      config={config}
    >
      <span
        data-testid="dnd-icon"
        ref={ref}
        className={cx(css`
          display: flex;
          align-items: center;
        `, styles['dnd-icon'])}
      >
        <Icon version="v2" icon="DragAndDrop" size="small" />
      </span>
    </Tooltip>
  )
})
